import React, { useState } from "react";
import "./index.sass";

export interface BtnProps {
  id?: number;
  icon: React.ReactNode;
  label: string;
  color: "purple" | "blue" | "orange" | "darkOrange" | "red";
  active?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

// Mapping from original color to a darker hover shade.
const hoverColors: { [key in BtnProps["color"]]: string } = {
  purple: "#5e2392", // darker purple
  blue: "#004ba0", // darker blue
  orange: "#cc6600", // darker orange
  darkOrange: "#b35900", // darker dark orange
  red: "#990000", // darker red
};

const Btn = ({
  label,
  icon,
  color,
  active = false,
  onClick,
  style = {},
}: BtnProps) => {
  const [isHovered, setIsHovered] = useState(false);

  // Apply the hover background only when the button is hovered AND not active.
  const combinedStyle: React.CSSProperties = {
    ...style,
    ...(isHovered && !active ? { backgroundColor: hoverColors[color] } : {}),
  };

  return (
    <div
      className={`csp-btn ${active ? `${color}-active` : ""}`}
      style={combinedStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {icon}
      <div>{label}</div>
    </div>
  );
};

export default Btn;
